import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'leaflet/dist/leaflet.css';
import { NotificationProvider } from './services/NotificationContext';
import store from './redux/store';
import { Provider } from 'react-redux';
import 'moment/locale/es';
import { CookieProvider } from './services/CookieContext';
import { ApolloProvider } from '@apollo/client';
import client from './services/ApolloClient';
import { ChakraProvider } from '@chakra-ui/react';
require('moment-timezone');

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

root.render(
	<React.StrictMode>
		<ChakraProvider>
			<ApolloProvider client={client}>
				<NotificationProvider>
					<CookieProvider>
						<Provider store={store}>
							<App />
						</Provider>
					</CookieProvider>
				</NotificationProvider>
			</ApolloProvider>
		</ChakraProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
